import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

var configApp = null;
if (process.env.NODE_ENV !== 'production') {
  configApp = require('../config/config.development.json');
} else {
  configApp = require('../config/config.production.json');
}

axios.defaults.baseURL = configApp.backendUrl;

Vue.configApp = configApp;
Vue.use(VueAxios, axios)

import App from './App.vue'
import router from './router'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import AudioRecorder from 'vue2-audio-recorder'



import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret,faUser,faPowerOff, faSearch, faPlayCircle, faEye, faStar, faCircle, faClock, faListAlt, faEllipsisV, faCommentAlt, faUserCircle, faArchive, faSms, faPaperPlane, faArrowCircleUp, faSignOutAlt, faPaperclip, faTrash, faFileAlt, faInfoCircle, faFont, faBolt, faLink, faHeadphones } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faUserSecret,
  faUser,
  faPowerOff,
  faSearch,
  faPlayCircle,
  faEye,
  faStar,
  faCircle,
  faClock,
  faListAlt,
  faEllipsisV,
  faCommentAlt,
  faUserCircle,
  faArchive,
  faSms,
  faWhatsapp,
  faPaperPlane,
  faArrowCircleUp,
  faSignOutAlt,
  faPaperclip,
  faTrash,
  faFileAlt,
  faInfoCircle,
  faFont,
  faBolt,
  faLink,
  faHeadphones
);
library.add(far)
library.add(fab)

Vue.component('ficon', FontAwesomeIcon)

import "./assets/css/area_operatore.css";

Vue.use(BootstrapVue)
Vue.use(AudioRecorder)



Vue.config.productionTip = false


Vue.mixin({
  data: function() {
    return {
      configApp: configApp
    }
  }
})

new Vue({
  router,
  render: h => h(App),
  created: function() {
    this.configApp = configApp;
  }  
}).$mount('#app')
